import { Component, input } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { WeatherMeasurement } from "@models";
import { DatePipe, DecimalPipe } from "@angular/common";

@Component({
  selector: 'app-troll-current',
  templateUrl: './current.component.html',
  styleUrls: ['./current.component.scss'],
  imports: [
    DatePipe,
    DecimalPipe,
    MatIconModule,
    MatListModule,
  ]
})
export class TrollCurrentComponent {
  measurement = input.required<WeatherMeasurement>();
}
